import React from "react";

import Drawer from "components/common/drawer/Drawer";

import PreviewJob from "./Preview.template";
import { Job } from "../../../models/job/Job";

export default function PreviewJobComponent({
  job,
  drawerProps
}: {
  job: Job;
  drawerProps?: any;
}) {
  return (
    <Drawer
      {...drawerProps}
      render={({ close }: { close: () => void }) => (
        <PreviewJob job={job} close={close} />
      )}
    />
  );
}
